import React, { Component }  from 'react'
import { Icon, Modal, Button, Form, Input, Select, Checkbox, Grid, Dropdown, Loader, Popup } from 'semantic-ui-react'
import constants from '../../constants';

const optionsGradeLevel = constants.breakdownGradeLevel;
const optionsPaymentSchedule = constants.paymentSchedule;
const optionsPaymentTypes = constants.paymentTypes;

const optionsEnrollmentStatus = [
  { key: 't', text: 'Temp', value: 'Temp' },
  { key: 'o', text: 'Ok', value: 'Ok' },
  { key: 'no', text: 'Not Ok', value: 'Not Ok' },
  { key: 'ot', text: 'Other', value: 'Other' },
]

class ApplicantsEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      applicantId: '',
      gradeLevel: '',
      paymentSchedule: '',
      toPayUponEnrollment: '--',
      reservationFee: '--',
      ueBalance: '--',
      amount: '--',
      unsettledBalance: '--',
      clearToEnroll: '',
      withESCSubsidy: false,
      withSHSVoucher: false,
      withOtherGrants: false,
      isPassed: false,
      hasPromisoryNote: false,
      isPaid: false,
      isPartiallyPaid: false,
      isStudent: false,
      isCurrentStudent: false,
      isPaymentDone: false,
      isReservationDone: false,
      schoolYears: [],
      schoolYearId: '',
      orNumber: '',
      orDate: '',
      paymentAmount: '',
      students: [],
      studentId: '',
      type: '',
      filename: ''
    };
  }

  handleChange = (e, { name, value }) => {
    if(name === 'reservationFee') {
      let ueBalance = 0;
      ueBalance = parseFloat(this.state.toPayUponEnrollment) - parseFloat(value)
      this.setState({ueBalance, reservationFee: value})
    } else if(name === 'ueBalance') {
      let reservationFee = 0;
      reservationFee = parseFloat(this.state.toPayUponEnrollment) - parseFloat(value)
      this.setState({reservationFee, ueBalance: value})
    } else {
      this.setState({ [name]: value })
    }
  }
  toggleSubsidy = () => this.setState((prevState) => ({ withESCSubsidy: !prevState.withESCSubsidy }))
  toggleVoucher = () => this.setState((prevState) => ({ withSHSVoucher: !prevState.withSHSVoucher }))
  toggleGrants = () => this.setState((prevState) => ({ withOtherGrants: !prevState.withOtherGrants }))
  togglePromisory = () => this.setState((prevState) => ({ hasPromisoryNote: !prevState.hasPromisoryNote }))
  togglePaid = () => this.setState((prevState) => ({ isPaid: !prevState.isPaid }))
  togglePartiallyPaid = () => this.setState((prevState) => ({ isPartiallyPaid: !prevState.isPartiallyPaid }))
  togglePassed = () => this.setState((prevState) => ({ isPassed: !prevState.isPassed }))

  handleSubmit = () => {
    const data = {
      applicantId: this.state.applicantId,
      gradeLevel: this.state.gradeLevel,
      paymentSchedule: this.state.paymentSchedule,
      toPayUponEnrollment: this.state.toPayUponEnrollment,
      reservationFee: this.state.reservationFee,
      ueBalance: this.state.ueBalance,
      amount: this.state.amount,
      unsettledBalance: this.state.unsettledBalance,
      clearToEnroll: this.state.clearToEnroll,
      withESCSubsidy: this.state.withESCSubsidy,
      withSHSVoucher: this.state.withSHSVoucher,
      withOtherGrants: this.state.withOtherGrants,
      hasPromisoryNote: this.state.hasPromisoryNote,
      isPaid: this.state.isPaid,
      isPartiallyPaid: this.state.isPartiallyPaid,
      isPassed: this.state.isPassed,
      filename: this.props.enrollmentFilename !== '' ? this.props.enrollmentFilename : this.state.applicant.filename ,
      gradeFilename: this.props.gradeFilename !== '' ? this.props.gradeFilename  : this.state.applicant.gradeFilename
    };
    this.props.handleUpdate(data,this.state.applicantId);
    this.setState({
      applicantId: '',
      gradeLevel: '',
      paymentSchedule: '',
      toPayUponEnrollment: '--',
      reservationFee: '--',
      ueBalance: '--',
      amount: '--',
      unsettledBalance: '--',
      clearToEnroll: '',
      withESCSubsidy: false,
      withSHSVoucher: false,
      withOtherGrants: false,
      hasPromisoryNote: false,
      isPaid: false,
      isPartiallyPaid: false,
      isPassed: false
    })
    this.closeModal();
  }

  handleSubmitPayment = (isPaymentUponEnrollment) => {
    const data = {
      orNumber: this.state.orNumber,
      orDate: this.state.orDate,
      amount: this.state.paymentAmount,
      studentId: this.state.applicant.studentId,
      type: this.state.type,
      filename: this.props.paymentFile ? this.props.paymentFile.name : null,
    };
    this.props.handleStudentPayment(data,this.state.applicantId,isPaymentUponEnrollment);
  }

  closeModal = () => this.setState({ showModal: false })

  openModal = () => this.setState({ showModal: true })

  componentDidMount() {
    this.setState({
      applicant: this.props.applicant,
      applicantId: this.props.applicant.applicantId,
      gradeLevel: this.props.applicant.gradeLevel,
      paymentSchedule: this.props.applicant.paymentSchedule,
      toPayUponEnrollment: this.props.applicant.toPayUponEnrollment,
      reservationFee: this.props.applicant.reservationFee,
      ueBalance: this.props.applicant.ueBalance,
      amount: this.props.applicant.amount,
      unsettledBalance: this.props.applicant.unsettledBalance,
      clearToEnroll: this.props.applicant.clearToEnroll,
      withESCSubsidy: this.props.applicant.withESCSubsidy,
      withSHSVoucher: this.props.applicant.withSHSVoucher,
      withOtherGrants: this.props.applicant.withOtherGrants,
      hasPromisoryNote: this.props.applicant.hasPromisoryNote,
      isPaid: this.props.applicant.isPaid,
      isPartiallyPaid: this.props.applicant.isPartiallyPaid,
      isPassed: this.props.applicant.isPassed,
      isStudent: this.props.applicant.isStudent,
      isCurrentStudent: this.props.applicant.isCurrentStudent,
      isPaymentDone: this.props.applicant.isPaymentDone,
      isReservationDone: this.props.applicant.isReservationDone,
      schoolYears: this.props.schoolYears,
      students: this.props.students
    })
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (JSON.stringify(prevProps.applicant) !== JSON.stringify(this.props.applicant) ) {
      this.setState({
        applicant: this.props.applicant,
        applicantId: this.props.applicant.applicantId,
        gradeLevel: this.props.applicant.gradeLevel,
        paymentSchedule: this.props.applicant.paymentSchedule,
        toPayUponEnrollment: this.props.applicant.toPayUponEnrollment,
        reservationFee: this.props.applicant.reservationFee,
        ueBalance: this.props.applicant.ueBalance,
        amount: this.props.applicant.amount,
        unsettledBalance: this.props.applicant.unsettledBalance,
        clearToEnroll: this.props.applicant.clearToEnroll,
        withESCSubsidy: this.props.applicant.withESCSubsidy,
        withSHSVoucher: this.props.applicant.withSHSVoucher,
        withOtherGrants: this.props.applicant.withOtherGrants,
        hasPromisoryNote: this.props.applicant.hasPromisoryNote,
        isPaid: this.props.applicant.isPaid,
        isPartiallyPaid: this.props.applicant.isPartiallyPaid,
        isPassed: this.props.applicant.isPassed,
        isStudent: this.props.applicant.isStudent,
        isCurrentStudent: this.props.applicant.isCurrentStudent,
        isPaymentDone: this.props.applicant.isPaymentDone,
        isReservationDone: this.props.applicant.isReservationDone,
      })
    }

    if (JSON.stringify(prevProps.schoolYears) !== JSON.stringify(this.props.schoolYears) ) {
      this.setState({
        schoolYears: this.props.schoolYears
      })
    }

    if (JSON.stringify(prevProps.students) !== JSON.stringify(this.props.students) ) {
      this.setState({
        students: this.props.students
      })
    }
  }

  render() {
    let optionsSchoolYears, optionsStudents;
    if (this.state.schoolYears) {
      optionsSchoolYears = this.state.schoolYears.map((schoolYear,index) => {
        return (
            { key: schoolYear.schoolYearId, value: schoolYear.schoolYearId, text: schoolYear.name }
        )
      })
    }
    if (this.state.students) {
      optionsStudents = this.state.students.map((student,index) => {
        const studentName = `${student.lastName}, ${student.firstName}`
        return (
            { key: student.studentId, value: student.studentId, text: studentName }
        )
      })
    }

    if (this.state.applicant === undefined || this.state.applicant === null) {
      return <Loader active inline='centered' />
    }
    return (
      <Modal
        trigger={
          <Popup
            on='hover'
            position='bottom center'
            size='tiny'
            trigger={
              <Button icon size='tiny' onClick={this.openModal}>
                <Icon name='pencil' />
              </Button>
            }
          >
            Edit Applicant Details
          </Popup>
        }
        open={this.state.showModal}
        onClose={this.closeModal}
        size='large'
        closeIcon
        >
        <Modal.Header>{`Update Applicant: ${this.state.applicant.lastName}, ${this.state.applicant.firstName}`}</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths='equal'>
              <Form.Field value={this.state.gradeLevel} name='gradeLevel' control={Select} label='Grade Level' options={optionsGradeLevel} placeholder='Grade Level' onChange={this.handleChange}/>
              <Form.Field value={this.state.paymentSchedule} name='paymentSchedule' control={Select} label='Payment Schedule' options={optionsPaymentSchedule} placeholder='Payment Schedule' onChange={this.handleChange}/>
              <Form.Field value={this.state.clearToEnroll} name='clearToEnroll' control={Select} label='Clear to Enroll' options={optionsEnrollmentStatus} placeholder='Clear to Enroll' onChange={this.handleChange}/>
            </Form.Group>
            {
              (this.state.isPassed || this.state.applicant.applicationType === 'old') &&
              <Form.Group widths='equal'>
                <Form.Field
                  value={this.state.toPayUponEnrollment}
                  name='toPayUponEnrollment'
                  control={Input}
                  label='To Pay Upon Enrollment'
                  placeholder='To Pay UponEnrollment'
                  onChange={this.handleChange}
                />
                {
                  this.state.isPartiallyPaid &&
                  <Form.Field
                    value={this.state.reservationFee}
                    name='reservationFee'
                    control={Input}
                    label='Reservation Fee'
                    placeholder='Reservation Fee'
                    onChange={this.handleChange}
                  />
                }
                {
                  this.state.isPartiallyPaid &&
                  <Form.Field
                    value={this.state.ueBalance}
                    name='ueBalance'
                    control={Input}
                    label='Upon Enrollment Balance'
                    placeholder='UE Balance'
                    onChange={this.handleChange}
                  />
                }
                <Form.Field
                  value={this.state.amount}
                  name='amount'
                  control={Input}
                  label='Next Payment'
                  placeholder='Amount'
                  onChange={this.handleChange}
                />
                <Form.Field
                  value={this.state.unsettledBalance}
                  name='unsettledBalance'
                  control={Input}
                  label='Unsettled Balance'
                  placeholder='Unsettled Balance'
                  onChange={this.handleChange}
                />
              </Form.Group>
            }
            {
              (this.state.isPassed || this.state.applicant.applicationType === 'old') &&
              <Form.Group>
                <Form.Field control={Checkbox} checked={this.state.withESCSubsidy} name='withSubsidy' label='With ESC Subsidy' onChange={this.toggleSubsidy} style={{paddingTop: '2em'}}/>
                <Form.Field control={Checkbox} checked={this.state.withSHSVoucher} name='withVoucher' label='With SHS Voucher' onChange={this.toggleVoucher} style={{paddingTop: '2em'}}/>
                <Form.Field control={Checkbox} checked={this.state.withOtherGrants} name='withOtherGrants' label='With Other Grants' onChange={this.toggleGrants} style={{paddingTop: '2em'}}/>
              </Form.Group>
            }
            {
              this.state.applicant.applicationType === 'new' &&
              <Form.Group widths='equal'>
                <Form.Field
                  control={Input}
                  type="file"
                  name='gradeFilename'
                  label={`Form 137(Report Card): ${this.props.gradeFilename || this.props.applicant.gradeFilename}`}
                  onChange={(e) => this.props.handleUploadGradeFileChange(e.target.files[0], this.props.applicant)}
                />
                <Form.Field
                  control={Input}
                  type="file"
                  name='requirements'
                  label={`Requirements: ${this.props.enrollmentFilename || this.props.applicant.filename}`}
                  onChange={(e) => this.props.handleUploadEnroolmentFileChange(e.target.files[0], this.props.applicant)}
                />
              </Form.Group>
            }

            <Form.Group>
              {
                this.state.applicant.applicationType === 'new' &&
                <Form.Field control={Checkbox} checked={this.state.isPassed} name='isPassed' label='Is Passed Academic Assessment' onChange={this.togglePassed} style={{paddingTop: '2em'}}/>
              }

              {
                (this.state.isPassed || this.state.applicant.applicationType === 'old') &&
                <Form.Field control={Checkbox} checked={this.state.isPaid} name='isPaid' label='Is Paid UE' onChange={this.togglePaid} style={{paddingTop: '2em'}}/>
              }

              {
                (this.state.isPassed || this.state.applicant.applicationType === 'old') &&
                <Form.Field control={Checkbox} checked={this.state.isPartiallyPaid} name='isPartiallyPaid' label='Is Partially Paid UE' onChange={this.togglePartiallyPaid} style={{paddingTop: '2em'}}/>
              }

              {
                (this.state.isPassed || this.state.applicant.applicationType === 'old') &&
                <Form.Field control={Checkbox} checked={this.state.hasPromisoryNote} name='hasPromisoryNote' label='Has Promisory Note' onChange={this.togglePromisory} style={{paddingTop: '2em'}}/>
              }
            </Form.Group>


            <Button fluid positive onClick={() => this.handleSubmit()}>Update Applicant</Button>
          </Form>
          <hr/>
          {
            this.state.applicant.applicationType === 'old' ?
              (this.state.isPaid || this.state.isPartiallyPaid || this.state.hasPromisoryNote) &&
              <Grid centered>
                <Grid.Row>
                  {
                    !this.state.isStudent &&
                    <div>
                      {
                        this.state.students.length === 0 ?
                        <h3 style={{marginBottom: 0, marginTop: '7px', marginRight: '14px'}}>No available student.</h3> :
                        <h3 style={{marginBottom: 0, marginTop: '7px', marginRight: '14px'}}>Possible Students:</h3>
                      }
                      {
                        this.state.students.length === 0 ?
                        <Button
                          onClick={() => this.props.getOldStudent(this.state.applicant.firstName, this.state.applicant.lastName)}
                          color='blue'
                        >
                          Get Possible Student
                        </Button> :
                        <>
                          <Button
                            onClick={() => this.props.getOldStudent(this.state.applicant.firstName, this.state.applicant.lastName)}
                            color='blue'
                          >
                            Get Possible Student
                          </Button>
                          <Dropdown
                            selection
                            name='studentId'
                            options={optionsStudents}
                            onChange={this.handleChange}
                            value={this.state.studentId}
                          />
                        </>
                      }
                    </div>
                  }

                  {
                    (this.state.students.length !== 0 || this.state.isStudent) &&
                    <Button
                      onClick={() => this.props.handleSaveAsOldStudent(this.state.applicant, this.state.studentId)}
                      color='blue'
                      icon
                      disabled={this.state.isStudent}
                      labelPosition='right'
                    >
                      {this.state.isStudent ? 'Saved Applicant as a Student' : 'Save Applicant as a Student'}
                      <Icon name={this.state.isStudent ? 'check' : 'minus'} />
                    </Button>
                  }

                </Grid.Row>
              </Grid>:
              (this.state.isPaid || this.state.isPartiallyPaid || this.state.hasPromisoryNote) &&
              <Grid centered>
                <Grid.Row>
                  <Button
                    onClick={() => this.props.handleSaveAsStudent(this.state.applicant)}
                    color='blue'
                    icon
                    disabled={this.state.isStudent}
                    labelPosition='right'
                  >
                    {this.state.isStudent ? 'Saved Applicant as a Student' : 'Save Applicant as a Student'}
                    <Icon name={this.state.isStudent ? 'check' : 'minus'} />
                  </Button>
                </Grid.Row>
              </Grid>
          }
          {
            (this.state.isStudent && this.state.isPartiallyPaid) &&
            <Grid centered>
              <Grid.Row>
                <Form>
                  {
                    !this.state.isReservationDone &&
                    <>
                    <Form.Group widths='equal'>
                      <Form.Field
                        value={this.state.orNumber}
                        name='orNumber'
                        control={Input}
                        label='OR Number'
                        placeholder='OR Number'
                        onChange={this.handleChange}
                      />
                      <Form.Field>
                        <label>OR Date</label>
                        <Input value={this.state.orDate} name='orDate' type='date' placeholder='OR Date' onChange={this.handleChange}/>
                      </Form.Field>
                      <Form.Select
                        fluid
                        search
                        clearable
                        name='type'
                        label='Type'
                        placeholder='Type'
                        options={optionsPaymentTypes}
                        defaultValue='Reservation'
                        onChange={this.handleChange}
                        value={this.state.type}
                      />
                      <Form.Field
                        value={this.state.paymentAmount}
                        name='paymentAmount'
                        control={Input}
                        label='Payment Amount'
                        placeholder='Payment Amount'
                        onChange={this.handleChange}
                      />
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <Form.Field
                        control={Input}
                        type="file"
                        label='OR Image'
                        placeholder='OR Image'
                        onChange={(e) => this.props.handleUploadFileChange(e.target.files[0])}
                      />
                    </Form.Group>
                    </>
                  }
                  <Button
                    onClick={() => this.handleSubmitPayment(false)}
                    color='blue'
                    icon
                    disabled={this.state.isReservationDone}
                    labelPosition='right'
                  >

                    {this.state.isReservationDone ? 'Reservation Recorded' : 'Record Student Reservation'}
                    <Icon name={this.state.isReservationDone ? 'check' : 'minus'} />
                  </Button>
                </Form>

              </Grid.Row>
            </Grid>
          }
          {
            (this.state.isStudent && this.state.isPaid) &&
            <Grid centered>
              <Grid.Row>
                <Form>
                  {
                    !this.state.isPaymentDone &&
                    <>
                    <Form.Group widths='equal'>
                      <Form.Field
                        value={this.state.orNumber}
                        name='orNumber'
                        control={Input}
                        label='OR Number'
                        placeholder='OR Number'
                        onChange={this.handleChange}
                      />
                      <Form.Field>
                        <label>OR Date</label>
                        <Input value={this.state.orDate} name='orDate' type='date' placeholder='OR Date' onChange={this.handleChange}/>
                      </Form.Field>
                      <Form.Select
                        fluid
                        search
                        clearable
                        name='type'
                        label='Type'
                        placeholder='Type'
                        options={optionsPaymentTypes}
                        onChange={this.handleChange}
                        value={this.state.type}
                      />
                      <Form.Field
                        value={this.state.paymentAmount}
                        name='paymentAmount'
                        control={Input}
                        label='Payment Amount'
                        placeholder='Payment Amount'
                        onChange={this.handleChange}
                      />
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <Form.Field
                        control={Input}
                        type="file"
                        label='OR Image'
                        placeholder='OR Image'
                        onChange={(e) => this.props.handleUploadFileChange(e.target.files[0])}
                      />
                    </Form.Group>
                    </>
                  }
                  <Button
                    onClick={() => this.handleSubmitPayment(true)}
                    color='blue'
                    icon
                    disabled={this.state.isPaymentDone}
                    labelPosition='right'
                  >

                    {this.state.isPaymentDone ? 'Payment Recorded' : 'Record Student Payment'}
                    <Icon name={this.state.isPaymentDone ? 'check' : 'minus'} />
                  </Button>
                </Form>

              </Grid.Row>
            </Grid>
          }
          {
            (this.state.isStudent && (this.state.isPaid || this.state.isPartiallyPaid || this.state.hasPromisoryNote)) &&
            <Grid centered>
              <Grid.Row>
                {
                  !this.state.isCurrentStudent &&
                  <Dropdown
                    selection
                    name='schoolYearId'
                    options={optionsSchoolYears}
                    onChange={this.handleChange}
                    value={this.state.schoolYearId}
                  />
                }


                <Button
                  onClick={() => this.props.handleAddStudentToSY(this.state.schoolYearId, this.state.applicant.studentId, this.state.applicantId, this.state.applicant.gradeLevel)}
                  color='blue'
                  icon
                  disabled={this.state.isCurrentStudent}
                  labelPosition='right'
                >

                  {this.state.isCurrentStudent ? 'Added Student to School Year' : 'Add Student to School Year'}
                  <Icon name={this.state.isCurrentStudent ? 'check' : 'minus'} />
                </Button>
              </Grid.Row>
            </Grid>
          }
        </Modal.Content>
        <Modal.Actions>

        </Modal.Actions>
      </Modal>
    )
  }
};

export default ApplicantsEdit;
